import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import { RegularSection } from '@/components/Layouts'
import { getImageData } from '@/utilites/getImageData'
import { formatDateTime } from '@/utilites/formatDateTime'
import Image from 'next/image'
import Link from 'next/link'

const CARD_SX = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    textDecoration: 'none',
    backgroundSize: 'cover',
    border: '1px solid var(--primary-color)',
    borderRadius: 5,
    p: 4,
    gap: 2,
}

interface Card {
    slug?: string
    sections?: Array<{
        content?: {
            title?: string
            excerpt?: string
            updatedAt?: string
            publishedAt?: string
            projectDate?: string
            image?: unknown
        }
    }>
}

interface Content {
    title?: string
}

interface S3_blogopen_3Props {
    content?: Content
    extraCards?: Card[]
    currentPageSlug?: string
    blockName?:string
}

const getGridSize = (count: number) => {
    if (count <= 0) return { xs: 12, md: 4 }
    if (count === 1) return { xs: 12, md: 12 }
    if (count === 2) return { xs: 12, md: 6 }
    return { xs: 12, md: 4 }
}

const Index = (props: S3_blogopen_3Props) => {
    const { content = {}, extraCards = [], currentPageSlug = '' } = props
    const cards = extraCards.filter((card) => (card?.slug ?? '') !== currentPageSlug)
    const gridSize = getGridSize(cards.length)
    return (
        <RegularSection aria-label='S3_blogopen_3' >
            <Grid size={12}>
                <Typography variant='h1'>{content?.title || ''}</Typography>
            </Grid>

            <Grid
                container
                spacing={4}
            >
                {cards.map((card, index) => {
                    const imageData = getImageData(card?.sections?.[0]?.content?.image)
                    // Use projectDate for ProjectHistory, publishedAt for Blog
                    const projectDate = card?.sections?.[0]?.content?.projectDate
                    const publishedAt = card?.sections?.[0]?.content?.publishedAt
                    const dateToShow = projectDate || publishedAt
                    const formattedDate = dateToShow ? formatDateTime(dateToShow) : ''
                    
                    return (
                    <Grid key={'S3_blogopen_3' + index} size={gridSize}>
                        <Link href={ '/' + (card?.slug || '')} style={{ textDecoration: 'none', display: 'block', width: '100%' }}>
                            <Box sx={{ ...CARD_SX }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'start',
                                        flex: 1,
                                        gap: 2,
                                    }}
                                >
                                    <Typography
                                        variant='body1'
                                        color='black'
                                    >
                                        {card?.sections?.[0]?.content?.title || ''}
                                    </Typography>
                                    <Typography
                                        variant='body2'
                                        color='black'
                                    >
                                        {card?.sections?.[0]?.content?.excerpt || ''}
                                    </Typography>
                                    {formattedDate && (
                                        <Typography
                                            variant='body2'
                                            color='black'
                                        >
                                            {formattedDate}
                                        </Typography>
                                    )}
                                </Box>
                                <Box
                                    sx={{
                                        position: 'relative',
                                        width: 200,
                                        height: 200,
                                        minWidth: 200,
                                        flexShrink: 0,
                                        flexGrow: 0,
                                        aspectRatio: '1',
                                        borderRadius: 2,
                                        overflow: 'hidden',
                                        backgroundColor: imageData.src ? 'transparent' : 'rgba(0, 0, 0, 0.05)',
                                    }}
                                >
                                    {imageData.src && (
                                        <Image
                                            src={imageData.src}
                                            alt={imageData.alt || card?.sections?.[0]?.content?.title || ''}
                                            fill
                                            sizes='200px'
                                            style={{ objectFit: 'cover' }}
                                            loading='lazy'
                                        />
                                    )}
                                </Box>
                            </Box>
                        </Link>
                    </Grid>
                )})}
            </Grid>
        </RegularSection>
    )
}

export default Index
